import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportStagesProgressWithWorks(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS_STAGES_PROGRESS_WITH_WORKS,
		ModulesConfigMap[ModulesMap.REPORTS_STAGES_PROGRESS_WITH_WORKS].GET_REPORTS_STAGES_PROGRESS_WITH_WORKS,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_STAGES_PROGRESS_WITH_WORKS].GET_REPORTS_STAGES_PROGRESS_WITH_WORKS]: _getReportStagesProgressWithWorks,
}